/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

import type { FeaturePageConfig } from "./types";

/**
 * Mirrors the original template string for the Capabilities section wrapper.
 */
export function getCapabilitiesSectionBgClass(
  config: Pick<FeaturePageConfig, "workflow" | "featureGrid">,
): string {
  if (config.workflow) return "bg-background";
  if (config.featureGrid) return "bg-background-warm";
  return "bg-background";
}
